export const tutorialCategories = [
  { id: 'all', label: 'Semua Video' },
  { id: 'instalasi', label: 'Instalasi & Akun' },
  { id: 'pembayaran', label: 'Pembayaran IPL' },
];

export const tutorialsData = [
  {
    id: 'instalasi-unknown-apps',
    title: 'Panduan Pemasangan Aplikasi Sistem IPL (Izin Sumber Tidak Dikenal / Unknown Apps)',
    shortTitle: 'Instalasi Aplikasi (Android)',
    platform: 'Android',
    brand: 'Instalasi APK',
    description:
      'Panduan lengkap langkah demi langkah mengenai cara mengunduh berkas APK resmi, memberikan izin pemasangan aplikasi dari sumber tidak dikenal (Install Unknown Apps), hingga berhasil memasang dan membuka aplikasi Sistem IPL.',
    videoUrl: 'https://storage.iplsistem.id/tutorial/Tutorial%20Instalasi%20Aplikasi%20IPL.mp4',
    category: 'instalasi',
    duration: 'Video Panduan',
    isFeatured: true,
    isAvailable: true,
    highlights: [
      'Mengunduh berkas APK resmi melalui situs web Sistem IPL',
      'Membuka berkas APK dan memilih menu "Setelan / Settings" saat muncul notifikasi keamanan',
      'Mengaktifkan izin "Izinkan dari sumber ini / Allow from this source"',
      'Melanjutkan pemasangan (Install) hingga selesai dan masuk ke dalam aplikasi'
    ],
    updatedAt: '2026-09-24',
  },
  {
    id: 'panduan-pembayaran-ipl',
    title: 'Panduan Pembayaran Tagihan IPL (Aplikasi Sistem IPL)',
    shortTitle: 'Panduan Pembayaran Tagihan IPL',
    platform: 'Android',
    brand: 'Pembayaran',
    description:
      'Panduan lengkap langkah demi langkah mengenai cara melakukan pembayaran tagihan iuran pemeliharaan lingkungan (IPL) secara praktis, cepat, dan aman melalui aplikasi Sistem IPL.',
    videoUrl: 'https://storage.iplsistem.id/tutorial/Tutorial%20Pembayaran%20Aplikasi%20IPL.mp4',
    category: 'pembayaran',
    duration: 'Video Panduan',
    isFeatured: false,
    isAvailable: true,
    highlights: [
      'Membuka aplikasi Sistem IPL dan masuk ke menu Tagihan atau Pembayaran',
      'Memeriksa rincian iuran dan periode tagihan yang ingin dibayarkan',
      'Memilih metode pembayaran yang tersedia (Virtual Account, Transfer, atau QRIS)',
      'Menyelesaikan pembayaran dan menyimpan bukti transaksi digital'
    ],
    updatedAt: '2026-09-24',
  },
];

